import {
  Component,
  OnInit,
  OnDestroy,
  Renderer2,
  ElementRef,
  ViewChild,
} from '@angular/core'
import { CommonService } from '../../../../shared/services/common.service'
import { Router, ActivatedRoute } from '@angular/router'
import { Observable, of } from 'rxjs'
import {
  FormControl,
  FormGroup,
  Validators,
  FormBuilder,
  ValidatorFn,
  AbstractControl,
} from '@angular/forms'
import {
  CmsService,
  AuthService,
  User,
  GlobalMessageService,
  GlobalMessageType,
} from '@spartacus/core'
import { switchMap } from 'rxjs/operators'
import { UserAccountFacade } from '@spartacus/user/account/root'
@Component({
  standalone: false,
  selector: 'vs-notify-email',
  templateUrl: './notify-email.component.html',
  styleUrls: ['./notify-email.component.scss'],
})
export class NotifyEmailComponent implements OnInit, OnDestroy {
  myprofile: FormGroup
  user$: Observable<User>
  public userTypes
  //public emailFormat = '^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}(\s*(,)\s*|\s*$))+$';
  //public emailFormat = '^[a-zA-Z0-9._%+-]+@(?!gmail\.com|yahoo\.com|hotmail\.com)(?:[a-zA-Z0-9.-]+\.?)+$';

  //public emailFormat = '^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}(\s*(,)\s*|\s*$))+$';
  public emailFormat =
    '^([a-zA-Z0-9._%+-]+@(?!gmail.com|yahoo.com|hotmail.com)(?:[a-zA-Z0-9.-]+.?)(s*(,)s*|s*$))+$'

  myprofiledetails: FormGroup
  myprofilenotify: FormGroup
  personaldetail: FormGroup
  isSubmitted = false
  public showSuccess = false
  invoiceEmail: string
  orderConfirmationEmail: string
  orderShipmentEmail: string
  @ViewChild('infoMsg', { static: false }) infoMsg: ElementRef
  @ViewChild('successMsg', { static: false }) successMsg: ElementRef
  constructor(
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private auth: AuthService,

    private globalMessageService: GlobalMessageService,
    private userAccountFacade: UserAccountFacade
  ) {}

  get formControlsNotify() {
    return this.myprofilenotify.controls
  }

  get orderacknowledgement() {
    return this.myprofilenotify.get('orderacknowledgement')
  }
  get shipnotify() {
    return this.myprofilenotify.get('shipnotify')
  }
  get invoicemail() {
    return this.myprofilenotify.get('invoicemail')
  }

  ngOnInit(): void {
    this.getEmailNotify()
    this.user$ = this.auth.isUserLoggedIn().pipe(
      switchMap((isUserLoggedIn) => {
        if (isUserLoggedIn) {
          return this.userAccountFacade.get()
        } else {
          return of(undefined)
        }
      })
    )

    // this.user$.subscribe((success) => {});

    this.myprofilenotify = this.formBuilder.group({
      orderacknowledgement: new FormControl('', [
        Validators.required,
        Validators.pattern(this.emailFormat),
        // this.mailListValidator().bind(this),
      ]) /* , Business requirement to remove invoiceEmail and shipNotificationEmail
      shipnotify: new FormControl('', [
        Validators.required,
        Validators.pattern(this.emailFormat),
        // this.mailListValidator().bind(this),
      ]),
      invoicemail: new FormControl('', [
        Validators.required,
        Validators.pattern(this.emailFormat),
        // this.mailListValidator().bind(this),
      ]), */,
    })
  }

  openSuccessMsg() {
    this.isSubmitted = true
    if (this.myprofilenotify.invalid) {
      return
    } else {
    }
  }

  getEmailNotify() {
    const params = ['users', 'current', 'notificationdetails']
    const apiUrl = this.commonService.constructUrl(params)
    this.commonService.getData(apiUrl).subscribe(
      (success) => {
        this.userTypes = success
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }
  goToTop() {
    window.scrollTo(0, 0)
  }
  sendEmailNotify() {
    let notifyEmailObj = {
      invoiceEmail: '',
      orderConfirmationEmail: this.myprofilenotify.value.orderacknowledgement,
      orderShipmentEmail: '',
    }
    const apiParam = ['users', 'current', 'notificationdetails']
    const apiUrl =
      this.commonService.constructUrl(apiParam) +
      '?invoiceEmail=' +
      notifyEmailObj.invoiceEmail +
      '' +
      '&orderConfirmationEmail=' +
      notifyEmailObj.orderConfirmationEmail +
      '' +
      '&orderShipmentEmail=' +
      notifyEmailObj.orderShipmentEmail +
      ''

    this.commonService.postData(apiUrl, notifyEmailObj).subscribe(
      (success) => {
        this.globalMessageService.add(
          { key: 'myProfile.profileUpdated' },
          GlobalMessageType.MSG_TYPE_CONFIRMATION,
          180000
        )
        this.isSubmitted = false
        this.goToTop()
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }
  postEmail() {
    this.isSubmitted = true
    if (this.myprofilenotify.invalid) {
      return
    } else {
      this.sendEmailNotify()
    }
  }
  clearEmail() {
    this.myprofilenotify.reset()
    this.getEmailNotify()
  }

  ngOnDestroy() {
    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_ERROR)
    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_WARNING)
    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_INFO)
    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_CONFIRMATION)
  }

  mailListValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      //check whether , is there in the string
      //split them into array
      //traverse the array and check each and throw error
      if (!control.value) {
        return null
      }
      var mailListArray = control.value.split(',')
      if (mailListArray.length > 0) {
        for (let i = 0; i < mailListArray.length; i++) {
          const regex = new RegExp(this.emailFormat)
          const valid = regex.test(mailListArray[i])
          const domainName = mailListArray[i].split('@').pop().split('.')[0]
          const secondEmailPart = mailListArray[i].split('@')[1]
          if (!valid) {
            return { invalidMail: true }
          } else if (
            domainName === undefined ||
            (domainName !== undefined && domainName.length === 0)
          ) {
            return { invalidMail: true }
          } else if (!mailListArray[i].split('@')[1].includes('.')) {
            return { invalidMail: true }
          } else if (
            secondEmailPart === undefined ||
            secondEmailPart.split('.')[1] === undefined ||
            (secondEmailPart.split('.')[1] !== undefined &&
              secondEmailPart.split('.')[1].length === 0)
          ) {
            return { invalidMail: true }
          }
        }
      }
      return null
    }
  }
}
